import { render } from "./InformationTransferableInscription.vue?vue&type=template&id=fc55136c"
import script from "./InformationTransferableInscription.vue?vue&type=script&lang=js"
export * from "./InformationTransferableInscription.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__